import type { JSX, ReactNode } from 'react';

import './TestWrapper.less';

const TestWrapper = ({ children }: { children: ReactNode }): JSX.Element => {
  return (
    <>
      {import.meta.env.VITE_ENVIRONMENT === 'test' && <div className="test-wrapper-notice">Test</div>}
      {children}
    </>
  );
};

export default TestWrapper;
